import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StateSupportModalType } from '#baseSupportModal/types';
import { REDUCER_SUPPORT_MODAL_NAME } from '#baseSupportModal/constants';

const initialState: StateSupportModalType = {
  isVisible: false,
  isLoaded: false,
  isLoadInProcess: false,
};

const sliceSupportModal = createSlice({
  name: REDUCER_SUPPORT_MODAL_NAME,
  initialState,
  reducers: {
    open: (state) => {
      state.isVisible = true;
    },
    hide: (state) => {
      state.isVisible = false;
    },
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    setIsLoadInProcess: (state, action: PayloadAction<boolean>) => {
      state.isLoadInProcess = action.payload;
    },
  },
});

const reducerSupportModal = sliceSupportModal.reducer;

const {
  open: supportModalOpen,
  hide: supportModalHide,
  setIsLoaded: supportModalSetIsLoaded,
  setIsLoadInProcess: supportModalSetIsLoadInProcess,
} = sliceSupportModal.actions;

export {
  reducerSupportModal,
  supportModalOpen,
  supportModalHide,
  supportModalSetIsLoaded,
  supportModalSetIsLoadInProcess,
};
